import { SuccessorBorrowerSideNav } from './SuccessorBorrowerSideNav';

export default SuccessorBorrowerSideNav;
